import { getMeta } from '@helpCenter/util/meta';
import { createRelayResource } from '@atlassian/help-center-common-util/resource-router';
import CsmRequestsListQuery, { type csmRequestsListQuery } from '../../ui/__generated__/csmRequestsListQuery.graphql';

export const csmRequestsListQueryResource = createRelayResource<csmRequestsListQuery>({
    type: 'CSM_REQUESTS_LIST_QUERY',
    getQuery: (_, { cloudId }) => ({
        parameters: CsmRequestsListQuery,
        variables: {
            cloudId,
            accountId: getMeta('account-id') ?? '',
        },
        options: {
            fetchPolicy: 'store-or-network',
        },
    }),
});
